import React from "react";
import Navbar from "../../components/Navbar";
import banner from "../../assets/home/bannerOrbs.avif";
import styles from "./style.module.scss";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import DropdownMenu from "../../components/DropdownMenu";
import SEO from "../../context/SEO";

function Error() {
  return (
    <div>
      <DropdownMenu />
      <SEO title="Cork Matters - Error" />
      <div className={styles.banner}>
        <img src={banner} alt="Orb Family Banner" />
        <div className={styles.errorContainer}>
          <h1 className={styles.errorTitle}>Error: Page not found</h1>
          <p className={styles.errorMessage}>
            Sorry, the page you are looking for does not exist. Please check the
            URL and try again.
          </p>
          <div className={`${styles.linkContainer} ${styles.justifyContentCenter}`}>
            <Link
              to="/"
              className={`${styles.isAlt} ${styles.underlineLink}`}
            >
              Go back to the home page
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Error;
